/* eslint-disable jsx-a11y/alt-text */
import * as React from "react";

import logo from "../resources/images/logo/logo.png";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Button } from "@mui/base";
import {
  Divider,
  Drawer,
  Grid,
  IconButton,
  List,
  ListItem,
  Stack,
  Typography,
  Box,
} from "@mui/material";
import { DONUS, NAVER_CAFE_LINK, NAVER_CAFE_LINK_NEW } from "../words";
import { NAVER_CAFE_LINK_NEWS } from "../words";

const Header = (props) => {
  const nowMediaQuery = props.nowMediaQuery;

  function refreshPage() {
    window.history.replaceState(null, null, " ", "/");
  }

  // function clickedModalBtn() {
  //   props.clickedModalBtn();
  // }

  const menus = [
    {
      title: "해피인 소개",
      link: "/about",
      items: [
        {
          title: "소개",
          link: "/about",
        },
        {
          title: "연혁",
          link: "/history",
        },
        {
          title: "오시는 길",
          link: "/directions",
        },
      ],
    },
    {
      title: "사업 소개",
      link: "/meal-sharing",
      items: [
        {
          title: "도시락 나눔/배달",

          link: "/meal-sharing",
        },
        {
          title: "대화 및 상담",
          link: "/counseling",
        },
        {
          title: "자조 공동체 지원",
          link: "/community",
        },
      ],
    },
    {
      title: "윗말협의회",
      link: "/self-help-group",
      items: [
        {
          title: "윗말협의회",
          link: "/self-help-group",
        },
      ],
    },
    {
      title: "후원‧봉사",
      link: "/donate",
      items: [
        {
          title: "후원 안내",
          link: "/donate",
        },
        {
          title: "봉사 안내",
          link: "/service",
        },
      ],
    },
    {
      title: "소식",
      items: [
        {
          title: "네이버 카페",
          type: "external-link",
          link: NAVER_CAFE_LINK,
        },
        {
          title: "새소식",
          type: "external-link",
          sub: true,
          link: NAVER_CAFE_LINK_NEW,
        },
        {
          title: "언론보도",
          type: "external-link",
          sub: true,
          link: NAVER_CAFE_LINK_NEWS,
        },
      ],
    },
  ];

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });
  const [open, setOpen] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  // const clickHandler = (event, menu) => {
  //   window.location.href = menu.link;
  // };

  const mobileMenu = (anchor) => (
    <Box
      sx={{
        zIndex: 99,
        fontSize: 100,
        width: anchor === "top" || anchor === "bottom" ? "auto" : 250,
      }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List sx={{ p: 0 }}>
        <ListItem
          key="menu_header"
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <img className="logo_img" src={logo} alt="로고" />
          <IconButton onClick={toggleDrawer(anchor, false)}>
            <CloseIcon sx={{ fontSize: 30 }} />
          </IconButton>
        </ListItem>
        <List sx={{ p: 3 }}>
          {menus.map((menu, index) => (
            <>
              <Divider sx={{ color: "#EDEDED" }} variant="fullWidth" />
              <Stack key={menu.title} disablePadding>
                <Link
                  key={menu.title}
                  noWrap
                  underline="none"
                  to={menu.link}
                  sx={{
                    color: "text.primary",
                    transition: (theme) => theme.transitions.create("all"),
                    "&:hover": { color: "primary.main" },
                  }}
                >
                  <Typography
                    variant="h5"
                    fontWeight={"600"}
                    className=""
                    my={2}
                  >
                    {menu.title}
                  </Typography>
                </Link>
                {menu.items?.map((item) => (
                  <Link key={item.title} noWrap underline="none" to={item.link}>
                    <Typography
                      variant="subtitle1"
                      fontSize={17}
                      sx={{
                        transition: (theme) => theme.transitions.create("all"),
                        "&:hover": { color: "success.main" },
                        mb: 1,
                      }}
                    >
                      {item.title}
                    </Typography>
                  </Link>
                ))}
              </Stack>
            </>
          ))}
        </List>
      </List>
    </Box>
  );

  function PcMenu(anchor) {
    return (
      <Box
        sx={{
          backgroundColor: "white",
          width: "100vw",
          height: "210px",
          position: "fixed",
          top: 0,
          right: 0,
          display: "flex",
          justifyContent: "center",
        }}
        onClick={toggleDrawer(anchor, false)}
        onKeyDown={toggleDrawer(anchor, false)}
      >
        <Grid
          className="contents-area"
          container
          sx={{
            pt: "90px",
            display: "flex",
            alignItems: "flex-start",
            justifyContent:
              nowMediaQuery === "pc" ? "flex-start" : "space-between",
            zIndex: nowMediaQuery === "pc" ? 99 : 2,
            position: "inherit",
          }}
        >
          <Grid item width={"92px"}></Grid>
          {menus.map((menu, index) => (
            <Grid item width={"160px"} ml={"60px"}>
              <Stack key={menu.title} disablePadding>
                {menu.items?.map((item) =>
                  item.type === "external-link" ? (
                    <a target="_blank" href={item.link} rel="noreferrer">
                      <Typography
                        variant="subtitle1"
                        fontSize={17}
                        ml={item.sub ? 2 : 0}
                        sx={{
                          transition: (theme) =>
                            theme.transitions.create("all"),
                          "&:hover": { color: "success.main" },
                          mb: 1,
                        }}
                      >
                        {item.sub ? "‧" : "- "}
                        {item.title}
                      </Typography>
                    </a>
                  ) : (
                    <Link
                      key={item.title}
                      noWrap
                      underline="none"
                      to={item.link}
                    >
                      <Typography
                        variant="subtitle1"
                        fontSize={17}
                        sx={{
                          transition: (theme) =>
                            theme.transitions.create("all"),
                          "&:hover": { color: "success.main" },
                          mb: 1,
                        }}
                      >
                        - {item.title}
                      </Typography>
                    </Link>
                  )
                )}
              </Stack>
            </Grid>
          ))}
        </Grid>
      </Box>
    );
  }

  return (
    <header
      style={{ backgroundColor: "white" }}
      onMouseEnter={handleOpen}
      onMouseLeave={handleClose}
    >
      <div className="header">
        {nowMediaQuery === "pc" ? (
          <Grid
            className="contents-area"
            container
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              zIndex: 100,
              position: "fixed",
              mt: 1.5,
            }}
          >
            <Grid
              item
              alt="logo"
              display={"flex"}
              alignItems={"center"}
              justifyContent={"center"}
            >
              <Link
                to="/"
                onClick={refreshPage}
                sx={{ height: "0px", display: "block" }}
              >
                <img
                  className="logo_img"
                  src={logo}
                  sx={{ marginRight: "10px" }}
                />
              </Link>
              {menus.map((item) => (
                <Box
                  width={"160px"}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"left"}
                  height={"100%"}
                  sx={{ zIndex: 999 }}
                  ml={"60px"}
                >
                  {item.type === "external-link" ? (
                    <a target="_blank" href={item.link} rel="noreferrer">
                      <Typography
                        ml={item.sub ? 2 : 0}
                        variant="subtitle1"
                        fontSize={17}
                        textAlign={"center"}
                        sx={{
                          transition: (theme) =>
                            theme.transitions.create("all"),
                          "&:hover": { color: "success.main" },
                        }}
                      >
                        {item.title}
                      </Typography>
                    </a>
                  ) : (
                    <Link noWrap underline="none" to={item.link}>
                      <Typography
                        variant="subtitle1"
                        fontSize={17}
                        textAlign={"center"}
                        sx={{
                          transition: (theme) =>
                            theme.transitions.create("all"),
                          "&:hover": { color: "success.main" },
                        }}
                      >
                        {item.title}
                      </Typography>
                    </Link>
                  )}
                </Box>
              ))}
              <Box
                width={"160px"}
                display={"flex"}
                alignItems={"center"}
                justifyContent={"center"}
                height={"100%"}
                sx={{ zIndex: 999 }}
                ml={"50px"}
                backgroundColor={"#2BAE66"}
                color={"white"}
                paddingY={1.3}
                paddingX={2}
                borderRadius={10}
              >
                <a href={DONUS} target="_blank" rel="noreferrer">
                  <Typography
                    variant="subtitle1"
                    fontSize={17}
                    textAlign={"center"}
                    sx={{
                      transition: (theme) => theme.transitions.create("all"),
                      "&:hover": { color: "success.main" },
                    }}
                  >
                    바로 후원하기
                  </Typography>
                </a>
              </Box>
              {open && <PcMenu />}
            </Grid>

            {/* <Grid>
              <Link
                to="/"
                onClick={refreshPage}
                sx={{ height: "0px", display: "block" }}
              >
                <img
                  className="logo_icon"
                  src={logo_kakao}
                  style={{ marginRight: "10px" }}
                />
              </Link>
              <a href={NAVER_CAFE_LINK}>
                <img className="logo_icon" src={logo_naver_cafe} />
              </a>
            </Grid> */}
          </Grid>
        ) : (
          <Grid
            container
            sx={{
              alignItems: "flex-start",
              justifyContent: "space-between",
              zIndex: 100,
              position: "fixed",
            }}
          >
            <Grid item alt="logo" m={1}>
              <Link
                to="/"
                onClick={refreshPage}
                sx={{ height: "0px", display: "block" }}
              >
                <img className="logo_img" src={logo} />
              </Link>
            </Grid>
            <Grid item m={1}>
              <React.Fragment key="top">
                <Button onClick={toggleDrawer("top", true)}>
                  <MenuIcon sx={{ color: "black", fontSize: 40 }} />
                </Button>
                <Drawer
                  anchor="top"
                  open={state["top"]}
                  onClose={toggleDrawer("top", false)}
                >
                  {mobileMenu("top")}
                </Drawer>
              </React.Fragment>
            </Grid>
          </Grid>
        )}
      </div>
    </header>
  );
};

export default Header;
